/**
 * Кнопки панели сделки — один словарь на панель расширения и панель «Чатов»: одна высота, один
 * радиус, одни состояния. Три уровня: `primary` — главное действие блока (одно), `outline` —
 * заметное, но не главное, `quiet` — второстепенное.
 */
const base =
  "inline-flex h-9 items-center justify-center gap-1.5 whitespace-nowrap rounded-[var(--radius-ui)] px-3 text-[13px] font-medium transition-colors duration-150 motion-reduce:transition-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent disabled:cursor-not-allowed disabled:opacity-50";
export const btn = {
  primary: `${base} bg-accent text-white hover:bg-accent-text disabled:hover:bg-accent`,
  outline: `${base} border border-accent text-accent-text hover:bg-accent-dim disabled:hover:bg-transparent`,
  quiet: `${base} border border-border bg-bg text-fg hover:border-border-strong hover:bg-bg-hover disabled:hover:border-border disabled:hover:bg-bg`,
};
